<template>
  <section v-if="isExpert" class="expert">
    {{ expertData }}
    <div class="container expert__container">
      <a :href="expertData.link" class="expert__img-wrapper">
        <img
          :src="expertData.photo"
          :alt="expertData.photoAlt"
          :title="expertData.aboutExpert"
          class="expert__img"
          loading="lazy"
        />
      </a>
      <div class="expert__info-wrapper">
        <div class="expert__info info">
          <h2
            class="text-color-navy info__section-title text-h6"
            v-html="$t('product.expertTitle')"
          />
          <h3 class="info__title" v-html="expertData.title" />
          <p class="info__subtitle text-description" v-html="expertData.descr" />
          <div class="info__btn-group">
            <span v-for="btn in buttons" :key="btn.title" class="info__link"
              ><img :src="btn.icon" alt="btn.title" class="info__icon" /> {{ btn.title }}</span
            >
          </div>
          <p class="info__about" v-html="expertData.aboutExpert" />
        </div>
        <app-button
          :url="expertData.btnUrl"
          :text="expertData.btnText"
          size="large"
          variant="secondary"
          type="button"
          @clicked="onBtnClick"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { getCurrentInstance, ref } from 'vue'

import camIcon from '@/assets/images/icons/cam.svg'
import msgIcon from '@/assets/images/icons/message.svg'
import pinIcon from '@/assets/images/icons/pin.svg'

import { useContentfulAutowireGlobal } from '@/components/common/contentful/composables/useContentfulAutowireGlobal'
import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import { useNavigation } from '@/composables/useNavigation'

export default {
  name: 'Expert',
  props: {
    parentComponentName: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const { navigateTo } = useNavigation()
    const { getImageUrl, getImageAlt } = useContentfulComponent()

    const instance = getCurrentInstance()
    const componentName = instance.type.name || ''
    const expertData = ref(null)
    const initData = (entry) => {
      if (entry && !entry.sys) {
        const expert = entry.experts && entry.experts[0].fields ? entry.experts[0].fields : {}
        expertData.value = {
          title: entry.title,
          descr: entry.paragraph,
          btnText: entry.actionButtonLabel,
          btnUrl: entry.actionButtonTarget,
          aboutExpert: expert.onHoverText,
          link: expert.link,
          photo: getImageUrl(expert.photo) ? getImageUrl(expert.photo) : null,
          photoAlt: getImageAlt(expert.photo, expert.onHoverText),
        }
      }
    }

    useContentfulAutowireGlobal({
      componentName,
      parentComponentName: props.parentComponentName,
      customInitData: initData,
    })
    return {
      navigateTo,
      expertData,
    }
  },
  data() {
    return {
      buttons: [
        {
          icon: camIcon,
          title: 'Video',
        },
        {
          icon: pinIcon,
          title: 'Blog',
        },
        {
          icon: msgIcon,
          title: 'Reference Guide',
        },
      ],
    }
  },
  computed: {
    isExpert() {
      return !!this.expertData
    },
  },
  methods: {
    onBtnClick() {
      this.navigateTo(this.expertData.btnUrl)
    },
  },
}
</script>
